export default __webpack_public_path__ + "static/media/image9.c912b003.svg";